import React, { FC } from 'react'

export type SubHeadProps = {
  classes?: string
  label?: string
}

export const SubHead: FC<SubHeadProps> = props => {
  const { classes, label } = props
  return <>{label && <h2 className={`${classes}`}>{label}</h2>}</>
}
